import React from 'react'
import { useTranslation } from 'react-i18next'
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import StateComponents from '../../../components/state-component/StateComponents';
// import { ReactComponent as SearchIcon } from '../../../assets/icons/close-square.svg'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { ButtonPrimary } from '../../../components/button/ButtonCustoms';
import { ManageState } from './manageState';
import TableCustom from '../../../components/table/tableCustom';
import ModalCustom from '../../../components/modal/ModalCustom';
import { debouncedApiCall } from '../../../utils/app.utils';

type Props = {}

const CourseManagement: React.FC = (props: Props) => {
    const { t } = useTranslation();
    const {
        data,
        handleRequestSort,
        headCells,
        page,
        pageLimit,
        renderData,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        totalItems,
        showModal,
        handleCloseModal,
        handleShowModal,
        formState,
        handleChangeFormState,
        handleSubmit,
        setSearch
    } = ManageState()
    return (
        <ContainerLayout
            title={t("COURSE_MANAGEMENT.TITLE")}
            content={
                <>
                    <div className='w-full flex justify-between'>
                        <span className='flex-1'>
                            <StateComponents
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            md: 4
                                        },
                                        fieldProps: {
                                            startAdornment: <SearchOutlinedIcon />,
                                            placeholder: t("COURSE_MANAGEMENT.SEARCH"),
                                            onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearch })
                                        }
                                    }
                                ]}
                            />
                        </span>
                        <span>
                            <ButtonPrimary
                                mode='add'
                                onClick={() => handleShowModal("ADD")}
                                buttonName={t("COURSE_MANAGEMENT.ADD")}
                            />
                        </span>
                    </div>
                    <div className='mt-10'>
                        <section className='w-full mt-10'>
                            <TableCustom
                                tableMinWidth={1920}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={data?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </section>
                    </div>


                    {showModal && (
                        <ModalCustom
                            open
                            title={showModal === "ADD" ? t("COURSE_MANAGEMENT.ADD") : showModal === 'VIEW' ? t("COURSE_MANAGEMENT.VIEW") : t("COURSE_MANAGEMENT.EDIT")}
                            subTitle={t("PLEASE_SELECT_LIST")}
                            onClose={handleCloseModal}

                            component={
                                <div className='w-full'>
                                    <StateComponents
                                        otherProps={{ spacing: 2 }}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                fieldProps: {
                                                    disabled: showModal === 'VIEW',
                                                    value: formState.subject_no,
                                                    heading: t("COURSE_MANAGEMENT.COURSE_CODE"),
                                                    placeholder: t("COURSE_MANAGEMENT.COURSE_CODE"),
                                                    onChange: (e) => handleChangeFormState('subject_no', e.target.value)
                                                },
                                                type: "TEXT_FIELD"
                                            },
                                            {
                                                seq: 2,
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                fieldProps: {
                                                    disabled: showModal === 'VIEW',
                                                    value: formState.subject_name,
                                                    heading: t("COURSE_MANAGEMENT.COURSE_NAME"),
                                                    placeholder: t("COURSE_MANAGEMENT.COURSE_NAME"),
                                                    onChange: (e) => handleChangeFormState('subject_name', e.target.value)
                                                },
                                                type: "TEXT_FIELD"
                                            },
                                            {
                                                seq: 3,
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                fieldProps: {
                                                    disabled: showModal === 'VIEW',
                                                    mode: "full_number",
                                                    value: formState.subject_credit,
                                                    heading: t("COURSE_MANAGEMENT.COURSE_CREDIT"),
                                                    placeholder: t("COURSE_MANAGEMENT.COURSE_CREDIT"),
                                                    onChange: (e) => handleChangeFormState('subject_credit', e.target.value)
                                                },
                                                type: "TEXT-MASK"
                                            },
                                        ]}
                                    />
                                    <div className='mt-6 w-full flex justify-center gap-4 items-center'>
                                        <span>
                                            <ButtonPrimary
                                                mode='del'
                                                buttonName={t("BUTTON.CANCEL")}
                                                onClick={handleCloseModal}
                                            />
                                        </span>
                                        {showModal !== 'VIEW' && (
                                            <span>
                                                <ButtonPrimary
                                                    mode='done'
                                                    buttonName={t("BUTTON.CONFIRM")}
                                                    disabled={!formState.subject_no || !formState.subject_name || !formState.subject_credit}
                                                    onClick={handleSubmit}
                                                />
                                            </span>
                                        )}
                                    </div>

                                </div>
                            }
                        />
                    )}
                </>
            }
        />
    )
}

export default CourseManagement